<div class="modol_comp">
    <div class="modal-header pb-0 pt-0">
        <div>
            <button class="button-close" mat-button [mat-dialog-close]="false">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path
                        d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z" />
                </svg>
            </button>
        </div>
    </div>
    <div class="modal-body pt-0">
        <h2> {{data?.heading }}</h2>
        <form class="" [formGroup]="addClientForm">
            <div class="row">
                <div class="form-group col-md-12 mt-0 mb-2">
                    <div class="form-group col-md-12 mt-4 mb-2">
                        <div class="image-upload" id="imagePreview" [style.backgroundImage]="'url('+imageUrl+')'">
                            <input type='file' id="imageUpload" accept=".jpeg, .jpg, .png" #fileInput
                                (change)="fileupload($event)"
                                [ngClass]="{ 'is-invalid': submitted && f['companyLogo'].errors}" />
                            <label for="logo" class="upload-field m-0" id="file-label">
                                <div class="file-thumbnail">
                                    <img src="assets/images/edit.svg" width="60px" height="60px">
                                </div>
                            </label>
                        </div>
                        <div *ngIf=" submitted && f['companyLogo'].errors" class="invalid-feedback invalid-profile">
                            <div *ngIf="submitted && f['companyLogo'].errors['required']">Company Logo is required.
                            </div>
                        </div>
                        <div *ngIf="imageInvalid" class="invalid-feedback invalid-profile">
                            <div>{{imageInvalidMsg}}</div>
                        </div>
                    </div>

                </div>
                <div class="form-group col-md-6">
                    <label class="">Company Name</label>
                    <input type="text" class="form-control mt-3" formControlName="companyName"
                        [maxlength]="maxLength.companyName"
                        [ngClass]="{ 'is-invalid': submitted && f['companyName'].errors}"
                        placeholder="Enter company name" />
                    <div *ngIf=" submitted && f['companyName'].errors" class="invalid-feedback">
                        <div *ngIf="submitted && f['companyName'].errors['required']">
                            {{validationErrorMessage.companyName}}</div>
                    </div>
                </div>
                <div class="form-group col-md-6">
                    <label class="">Website</label>
                    <input type="text" class="form-control mt-3" formControlName="website"
                        [ngClass]="{ 'is-invalid': submitted && f['website'].errors}" placeholder="https://abc.xyz" />
                    <!-- <div *ngIf=" submitted && f['website'].errors" class="invalid-feedback">
                        <div *ngIf="submitted && f['website'].errors['required']">{{'Website is required.'}}</div>
                    </div> -->
                    <div *ngIf="submitted && f['website'].errors" class="invalid-feedback">
                        <div *ngIf="submitted && (f['website'].errors['website'] || f['website'].errors['pattern'] )">
                            {{'Enter a valid website name.'}}</div>
                    </div>
                </div>
                <ng-container formArrayName='phone'>
                    <ng-container *ngFor="let stand of getPhone(addClientForm); let i = index;" [formGroupName]="i">
                        <div class="form-group col-md-6 country-code">
                            <label class="">Phone</label>
                            <div class="country-code-input pe-1">
                                <div class="d-flex align-items-center">
                                    <div>+1</div> &nbsp;
                                    <div class="drop-down-icon"></div>
                                </div>
                            </div>
                            <input type="text" class="form-control mt-3 ps-3 " formControlName="number"
                                [maxlength]="maxLength.phoneNumber" [minlength]="maxLength.phoneNumber"
                                (keypress)="validationService.numberOnly($event)"
                                [ngClass]="{ 'is-invalid': submitted && stand.get('number')?.errors}"
                                placeholder="Enter phone number" [value]="phoneNumber" />
                            <div *ngIf=" submitted && stand.get('number')?.errors" class="invalid-feedback">
                                <div *ngIf="submitted && stand.get('number')?.errors['required']">
                                    {{validationErrorMessage.phoneNumber}} </div>
                            </div>
                            <div *ngIf=" submitted && stand.get('number')?.errors" class="invalid-feedback">
                                <div *ngIf="submitted && stand.get('number')?.errors['minlength']">
                                    {{'Minimum 10 characters required.'}} </div>
                            </div>
                        </div>
                        <div class="form-group col-md-6">
                            <div class="d-flex align-items-center justify-content-between">
                                <label>Type</label>
                                <div *ngIf="getPhone(addClientForm).length > 1"><img
                                        style="margin-top: 20px;cursor: pointer;" src="assets/images/black-cross.svg"
                                        (click)="removePhone(i)" /></div>
                            </div>
                            <mat-select class="form-control mt-3" formControlName="category"
                                aria-label="Default select example" placeholder='Select type'
                                [ngClass]="{ 'is-invalid': submitted && stand.get('category')?.errors}">
                                <mat-option [value]="item" *ngFor="let item of phoneCategoryArray">{{item}}</mat-option>
                            </mat-select>
                            <div *ngIf=" submitted && stand.get('category')?.errors" class="invalid-feedback">
                                <div *ngIf="submitted && stand.get('category')?.errors['required']">
                                    {{'Phone Type is required.'}} </div>
                            </div>
                        </div>
                    </ng-container>

                </ng-container>
                <div class="form-group col-md-12 link">
                    <img src="assets/images/add_circle_outline.png" (click)="addMoreNumber()" />&nbsp;<span
                        (click)="addMoreNumber()">Add Phone</span>
                </div>
                <ng-container *ngIf="data.type !== 2">
                    <div class="form-group col-md-6">
                        <label class="">Payment Mode</label>
                        <mat-select #payment class="form-control mt-3" formControlName="paymentMode"
                            [disabled]="data.type == 2"
                            [ngClass]="{ 'is-invalid': submitted && f['paymentMode'].errors}"
                            placeholder="Select Payment Mode" (selectionChange)="isOnline($event)">
                            <mat-option *ngFor="let mode of paymentModeArray"
                                [value]="mode?.value">{{mode.type}}</mat-option>
                        </mat-select>
                        <div *ngIf=" submitted && f['paymentMode'].errors" class="invalid-feedback">
                            <div *ngIf="submitted && f['paymentMode'].errors['required']"> Payment Mode is required.
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-md-6">
                        <label class="">Subscription Package</label>
                        <mat-select class="form-control mt-3" formControlName="package" [disabled]="data.type == 2"
                            (selectionChange)="setAmount($event)"
                            [ngClass]="{ 'is-invalid': submitted && f['package'].errors}" placeholder="Select package">
                            <mat-option *ngFor="let mode of packageList"
                                [value]="mode?._id">{{mode?.packageName}}</mat-option>
                        </mat-select>
                        <div *ngIf=" submitted && f['package'].errors" class="invalid-feedback">
                            <div *ngIf="submitted && f['package'].errors['required']"> Subscription Package is required.
                            </div>
                        </div>
                    </div>
                    <!-- Number of trucks -->
                    <div class="form-group col-md-6">
                        <label class=""># of trucks</label>
                        <input type="number" class="form-control mt-3" formControlName="numberOfTrucks" min="1"
                            [max]="maxTrucks" maxlength="2" (input)="limitInput($event)"
                            [ngClass]="{ 'is-invalid': submitted && f['numberOfTrucks'].errors}"
                            placeholder="Enter Number on Trucks" />
                        <div *ngIf=" submitted && f['numberOfTrucks'].errors" class="invalid-feedback">
                            <div *ngIf="submitted && f['numberOfTrucks'].errors['required']">
                                please enter how many trucks you would like to schedule
                            </div>
                            <div *ngIf="submitted && f['numberOfTrucks'].errors?.['min']" class="text-danger">
                                Minimum value allowed is 1
                            </div>

                            <div *ngIf="submitted && f['numberOfTrucks'].errors?.['max']" class="text-danger">
                                Maximum value allowed is {{maxTrucks}}
                            </div>
                        </div>
                    </div>
                    <!-- Number Of trucks -->

                    <!-- ADD ONS -->
                    <div class="form-group col-md-6">
                        <label class="">Add-Ons</label>

                        <mat-select class="form-control mt-3" formControlName="addOns" multiple
                            (selectionChange)="setAddOns($event)"
                            [ngClass]="{ 'is-invalid': submitted && f['addOns'].errors }" placeholder="Select Add-Ons">
                            <mat-option *ngFor="let add of AddOnsArray" [value]="add.value">
                                {{ add.type }}
                            </mat-option>
                        </mat-select>

                        <div *ngIf="submitted && f['addOns'].errors" class="invalid-feedback">
                            <div *ngIf="f['addOns'].errors['required']">
                                At least one Add-On is required.
                            </div>
                        </div>
                    </div>
                    <!-- ADDS ONS -->
                    <div class="form-group col-md-6">
                        <label class="">Start Date</label>
                        <div class="date mt-3" [ngClass]="{ 'is-invalid': submitted && f['startDate'].errors}">
                            <input type="text" matInput [min]="todayDate" [matDatepicker]="dp2" (click)="dp2.open()"
                                [disabled]="true" readonly placeholder="MMM DD, YYYY" formControlName='startDate'>
                            <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
                            <mat-datepicker #dp2></mat-datepicker>
                        </div>
                        <div *ngIf=" submitted && f['startDate'].errors" class="invalid-feedback">
                            <div *ngIf="submitted && f['startDate'].errors['required']">
                                {{validationErrorMessage.date}}
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-md-6">
                        <div class="dollar">
                            <span class="">$</span>
                            <label class="">Subscription Payment Received</label>
                            <input type="number" class="form-control mt-3" formControlName="amount"
                                [readOnly]="data.type == 2" (keydown.space)="$event.preventDefault()"
                                (keypress)="validationService.numberWithDecimal($event)" (blur)="setTodecimal()"
                                [ngClass]="{ 'is-invalid': submitted && f['amount'].errors}"
                                placeholder="Enter amount" />
                        </div>
                        <div *ngIf=" submitted && f['amount'].errors" class="invalid-feedback">
                            <div *ngIf="submitted && f['amount'].errors['required']; else notZero">
                                Subscription Payment is required
                            </div>
                            <ng-template #notZero>
                                <div *ngIf="f['amount'].errors['nonZero']">Amount must be greater than 0</div>
                            </ng-template>
                        </div>
                    </div>
                </ng-container>


                <ng-container formArrayName='serviceAddress'>
                    <ng-container *ngFor="let stand of getAddress(addClientForm); let i = index;" [formGroupName]="i">
                        <div class="form-group col-md-12">
                            <div class="custom-check-address d-flex justify-content-between">
                                <label class="">Company Address</label>
                                <div class="custom-control custom-checkbox d-flex align-items-center">
                                    <label class="custom-control-label" for="serviceCheck">Primary Address </label>
                                    <input type="checkbox" class="custom-control-input" id="serviceCheck"
                                        name="serviceCheck" formControlName="isPrimary"
                                        (change)="onCheckboxChange(i)" />
                                    <div *ngIf="getAddress(addClientForm).length > 1" class="handIcon"><img
                                            class="crossIcon" src="assets/images/black-cross.svg"
                                            (click)="removeAddress(i)" /></div>

                                </div>
                            </div>
                            <div class="search">
                                <!-- <input type="search" class="form-control mt-3 search-input"
                                    ngx-google-places-autocomplete #placesRef="ngx-places" [options]="options"
                                    (search)="clearSearch($event)" (onAddressChange)="handleAddressChange($event,2,i)"
                                    placeholder="Search...." /> -->
                                <app-address-auto-complete [index]="i" [selectedAddress]="selectedAddressText[i]"
                                    (placeSelected)="handleAddressChange($event, 2, i)"></app-address-auto-complete>
                                <img class="search-icon" src="assets/images/search.svg" width="18px" />
                            </div>
                        </div>
                        <div class="form-group col-md-6">
                            <input type="text" class="form-control mt-3" formControlName="addressLine1"
                                [ngClass]="{ 'is-invalid': submitted && addressControls.controls[i]['controls']['addressLine1'].errors}"
                                placeholder="Address line" />
                            <div *ngIf=" submitted && addressControls.controls[i]['controls']['addressLine1'].errors"
                                class="invalid-feedback">
                                <div
                                    *ngIf="submitted && addressControls.controls[i]['controls']['addressLine1'].errors['required']">
                                    {{validationErrorMessage.address}}
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-md-6">
                            <input type="text" class="form-control mt-3" formControlName="addressLine2"
                                [ngClass]="{ 'is-invalid': submitted && addressControls.controls[i]['controls'].errors}"
                                placeholder="Address line" />
                            <div *ngIf=" submitted && addressControls.controls[i]['controls']['addressLine2'].errors"
                                class="invalid-feedback">
                                <div
                                    *ngIf="submitted && addressControls.controls[i]['controls']['addressLine2'].errors['required']">
                                    {{validationErrorMessage.address}}
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-md-3">
                            <input type="text" class="form-control mt-3" formControlName="city"
                                [ngClass]="{ 'is-invalid': submitted && addressControls.controls[i]['controls']['city'].errors}"
                                placeholder="City" />
                            <div *ngIf=" submitted && addressControls.controls[i]['controls']['city'].errors"
                                class="invalid-feedback">
                                <div
                                    *ngIf="submitted && addressControls.controls[i]['controls']['city'].errors['required']">
                                    {{validationErrorMessage.city}} </div>
                            </div>
                        </div>
                        <div class="form-group col-md-3">
                            <input type="text" class="form-control mt-3" formControlName="state"
                                [ngClass]="{ 'is-invalid': submitted && addressControls.controls[i]['controls']['state'].errors}"
                                placeholder="State" />
                            <div *ngIf=" submitted && addressControls.controls[i]['controls']['state'].errors"
                                class="invalid-feedback">
                                <div
                                    *ngIf="submitted && addressControls.controls[i]['controls']['state'].errors['required']">
                                    {{validationErrorMessage.state}} </div>
                            </div>
                        </div>
                        <div class="form-group col-md-3">
                            <input type="text" class="form-control mt-3" formControlName="country"
                                [ngClass]="{ 'is-invalid': submitted && addressControls.controls[i]['controls']['country'].errors}"
                                placeholder="Country" />
                            <div *ngIf=" submitted && addressControls.controls[i]['controls']['country'].errors"
                                class="invalid-feedback">
                                <div
                                    *ngIf="submitted && addressControls.controls[i]['controls']['country'].errors['required']">
                                    {{validationErrorMessage.country}}
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-md-3">
                            <input type="text" class="form-control mt-3" formControlName="zipCode"
                                [ngClass]="{ 'is-invalid': submitted && addressControls.controls[i]['controls']['zipCode'].errors}"
                                placeholder="Zip Code" />
                            <div *ngIf=" submitted && addressControls.controls[i]['controls']['zipCode'].errors"
                                class="invalid-feedback">
                                <div
                                    *ngIf="submitted && addressControls.controls[i]['controls']['zipCode'].errors['required']">
                                    {{validationErrorMessage.zipCode}}
                                </div>
                            </div>
                            <div *ngIf="submitted && addressControls.controls[i]['controls']['zipCode'].errors"
                                class="invalid-feedback">
                                <div
                                    *ngIf="submitted && (addressControls.controls[i]['controls']['zipCode'].errors['zipCode'] || addressControls.controls[i]['controls']['zipCode'].errors['pattern'] )">
                                    {{validationErrorMessage.validZipCode}}</div>
                            </div>

                        </div>
                    </ng-container>
                </ng-container>
                <div class="form-group col-md-12 link">
                    <svg-icon src="assets/images/add_circle_outline.svg" (click)="addServiceAddress()"></svg-icon> <span
                        (click)="addServiceAddress()">Add Company Address</span>
                </div>

                <div class="form-group col-md-12">
                    <label>Industries</label>
                    <mat-select class="form-control mt-3" formControlName="serviceId" #select multiple
                        [ngClass]="{ 'is-invalid': submitted && f['serviceId'].errors}" placeholder="Select Industries">
                        <label class="main d-flex justify-content-start align-items-center">
                            <input type="checkbox" [(ngModel)]="allSelected" [ngModelOptions]="{standalone: true}"
                                (change)="toggleAllSelection()" hidden>
                            <span class="geekmark"></span>
                            <span class="px-2">{{ 'Select All'}}</span>
                        </label>
                        <mat-option *ngFor="let service of serviceList" [value]="service?._id"
                            (click)="optionClick()">{{service.serviceName}}</mat-option>
                    </mat-select>
                    <div *ngIf=" submitted && f['serviceId'].errors" class="invalid-feedback">
                        <div *ngIf="submitted && f['serviceId'].errors['required']"> Industries are required. </div>
                    </div>
                </div>

                <div class="form-group col-md-12 mt-3 ">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="contact-heading">CONTACT INFORMATION</div>
                        <div class="add-contact">
                            <img src="assets/images/add_circle_outline.png" (click)="addMoreContact()" />&nbsp;<span
                                (click)="addMoreContact()">Add Contact</span>
                        </div>
                    </div>
                </div>
                <ng-container formArrayName='contact'>
                    <ng-container *ngFor="let stand of getContact(addClientForm); let i = index;" [formGroupName]="i">
                        <div class="form-group col-md-12 mt-3">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="contact-count">Contact Person {{i+1}}</div>
                                <div *ngIf="getContact(addClientForm).length > 1"><img class="hand-icon"
                                        src="assets/images/black-cross.svg" (click)="removeContact(i)" /></div>
                            </div>
                        </div>
                        <div class="form-group col-md-12">
                            <label class="">Title / Role</label>
                            <input type="text" class="form-control mt-3" formControlName="contactTitle"
                                (keypress)="validationService.alphabetOnly($event)"
                                [ngClass]="{ 'is-invalid': submitted &&  stand.get('contactName')?.errors}"
                                placeholder="Enter Role title" />
                            <div *ngIf=" submitted && stand.get('contactTitle').errors" class="invalid-feedback">
                                <div *ngIf="submitted && stand.get('contactTitle').errors['required']">{{'Title / Role
                                    is
                                    required'}}</div>
                            </div>
                        </div>
                        <div class="form-group col-md-6">
                            <label class="">Contact name</label>
                            <input type="text" class="form-control mt-3" formControlName="contactName"
                                [maxlength]="maxLength.clientName" (keypress)="validationService.alphabetOnly($event)"
                                [ngClass]="{ 'is-invalid': submitted &&  stand.get('contactName')?.errors}"
                                placeholder="Enter contact name" />
                            <div *ngIf=" submitted && stand.get('contactName').errors" class="invalid-feedback">
                                <div *ngIf="submitted && stand.get('contactName').errors['required']">{{'Contact name is
                                    required'}}</div>
                            </div>
                        </div>
                        <div class="form-group col-md-6">
                            <label class="">Email Address</label>
                            <input type="text" class="form-control mt-3" formControlName="contactEmail"
                                [ngClass]="{ 'is-invalid': submitted && stand.get('contactEmail').errors}"
                                [maxlength]="maxLength.email" (keydown.space)="$event.preventDefault()"
                                placeholder="Enter email address" />
                            <div *ngIf=" submitted && stand.get('contactEmail').errors" class="invalid-feedback">
                                <div *ngIf="submitted && stand.get('contactEmail').errors['required']">
                                    {{validationErrorMessage.email}} </div>
                            </div>
                            <div *ngIf="submitted && stand.get('contactEmail').errors" class="invalid-feedback">
                                <div
                                    *ngIf="submitted && (stand.get('contactEmail').errors['email'] || stand.get('contactEmail').errors['pattern'] )">
                                    {{validationErrorMessage.validEmail}}</div>
                            </div>
                        </div>

                        <div class="form-group col-md-6 country-code">
                            <label class="">Phone</label>
                            <div class="country-code-input pe-1">
                                <div class="d-flex align-items-center">
                                    <div>+1</div> &nbsp;
                                    <div class="drop-down-icon"></div>
                                </div>
                            </div>
                            <input type="text" class="form-control mt-3 ps-3 " formControlName="contactNumber"
                                [maxlength]="maxLength.phoneNumber" [minlength]="maxLength.phoneNumber"
                                (keypress)="validationService.numberOnly($event)"
                                [ngClass]="{ 'is-invalid': submitted && stand.get('contactNumber')?.errors}"
                                placeholder="Enter phone number" [value]="phoneNumber" />
                            <div *ngIf=" submitted && stand.get('contactNumber')?.errors" class="invalid-feedback">
                                <div *ngIf="submitted && stand.get('contactNumber')?.errors['required']">
                                    {{validationErrorMessage.phoneNumber}} </div>
                            </div>
                            <div *ngIf=" submitted && stand.get('contactNumber')?.errors" class="invalid-feedback">
                                <div *ngIf="submitted && stand.get('contactNumber')?.errors['minlength']">
                                    {{'Minimum 10 characters required.'}} </div>
                            </div>
                        </div>
                        <div class="form-group col-md-6">
                            <div class="d-flex align-items-center justify-content-between">
                                <label>Type</label>
                            </div>
                            <mat-select class="form-control mt-3" formControlName="contactCategory"
                                aria-label="Default select example" placeholder='Select type'
                                [ngClass]="{ 'is-invalid': submitted && stand.get('contactCategory')?.errors}">
                                <mat-option [value]="item" *ngFor="let item of phoneCategoryArray">{{item}}</mat-option>
                            </mat-select>
                            <div *ngIf=" submitted && stand.get('contactCategory')?.errors" class="invalid-feedback">
                                <div *ngIf="submitted && stand.get('contactCategory')?.errors['required']">
                                    {{'Phone Type is required.'}} </div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </form>
    </div>
    <div class="modal-footer d-flex justify-content-between mt-3">
        <button type="button" class="btn cancel" [mat-dialog-close]="false">Cancel</button>
        <button type="submit" class="btn reset" (click)="resetForm()">Reset</button>
        <button type="submit" class="btn delete" (click)=" submitForm(addClientForm.getRawValue())">{{data?.type == 1 ?
            'Create
            Client Profile': 'Save Changes'}}</button>

    </div>

</div>